var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$config.app.githubUrl)?_c('p',[_c('a',{staticClass:"version hover:underline hover:text-primary-lighten",attrs:{"href":_vm.$config.app.githubUrl,"target":"_blank"}},[_vm._v("\n    v"+_vm._s(_vm.$config.version)+"\n  ")])]):_c('p',[_c('span',{staticClass:"version"},[_vm._v("\n    v"+_vm._s(_vm.$config.version)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }